export default {"src":"/_next/static/media/Twitter_Icon.0c231696.svg","height":75,"width":79,"blurWidth":0,"blurHeight":0};